import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const LeaveDataTable = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const navigate = useNavigate();

    const getLeaves = async () => {
        try {
            const response = await fetch(
                'https://api.experts4u.in/api/v1/ServiceProviderleaves/AllProviderleaves'
            );
            const result = await response.json();

            const filteredData = result.data
                .filter(user => user.leaves.length > 0)
                .map(user => ({
                    ...user,
                    leaves: user.leaves.sort((a, b) => new Date(b.CreatedAt) - new Date(a.CreatedAt))
                }));

            setData(filteredData);
        } catch (error) {
            console.error('Error fetching leaves:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getLeaves();
    }, []);

    const filteredData = data.filter(user => {
        const searchLower = searchTerm.toLowerCase();
        return (
            user?.Name?.toLowerCase().includes(searchLower) ||
            String(user?.ContactNo)?.toLowerCase().includes(searchLower) ||
            user?.leaves?.some(leave => 
                leave?.Status?.toLowerCase().includes(searchLower) ||
                leave?.Reason?.toLowerCase().includes(searchLower)
            )
        );
    });

    const paginatedData = filteredData.flatMap(user => user.leaves.map(leave => ({ user, leave })))
        .slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
    const totalPages = Math.ceil(filteredData.flatMap(user => user.leaves).length / itemsPerPage);

    return (
        <div className="p-5">
            <h2 className="text-xl font-bold mb-4 mt-3">Leave Data</h2>
            
            <div className="mb-4">
                <input
                    type="text"
                    placeholder="Search by name, phone, status or reason..."
                    className="w-full p-2 border border-gray-300 rounded"
                    value={searchTerm}
                    onChange={(e) => {
                        setSearchTerm(e.target.value);
                        setCurrentPage(1);
                    }}
                />
            </div>

            {loading ? (
                <p>Loading...</p>
            ) : (
                <>
                    <div className="overflow-x-auto">
                        <table className="w-[100vw] table-fixed border-collapse border border-gray-300" style={{width: '100%'}}>
                            <thead>
                                <tr className="bg-gray-200">
                                    <th className="border p-2 w-1/5">User Name</th>
                                    <th className="border p-2 w-1/5">Phone Number</th>
                                    <th className="border p-2 w-2/5">Reason</th>
                                    <th className="border p-2 w-1/5">Status</th>
                                    <th className="border p-2 w-1/5">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {paginatedData.map(({ user, leave }, index) => (
                                    <tr key={`${user._id}-${index}`}>
                                        <td className="border p-2 truncate">{user.Name}</td>
                                        <td className="border p-2 truncate">{user.ContactNo}</td>
                                        <td className="border p-2 truncate">{leave.Reason.length > 200 ? leave.Reason.slice(0, 200) + '...' : leave.Reason}</td>
                                        <td className="border p-2 truncate">{leave.Status}</td>
                                        <td className="border p-2">
                                            <button 
                                                className="btn btn-primary"
                                                onClick={() => navigate(`/leaves/${user?.ContactNo}`, { state: { leaveData: leave } })}
                                            >
                                                View
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                   <div style={{display:"flex",justifyContent:"center",alignItems:"center"}}>
                   <div className="flex justify-between mt-4  " >
                        <button 
                            className="btn btn-secondary"
                            disabled={currentPage === 1}
                            onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                        >
                            Previous
                        </button>
                        <span className="mx-5" >Page {currentPage} of {totalPages}</span>
                        <button 
                            className="btn btn-secondary"
                            disabled={currentPage === totalPages}
                            onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                        >
                            Next
                        </button>
                    </div>
                   </div>
                </>
            )}
        </div>
    );
};

export default LeaveDataTable;